const NAME = "PROJECTS";

export default NAME;
